// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CreatableSelectController from "./creatable_select_controller"
application.register("creatable-select", CreatableSelectController)

import DashboardChartsController from "./dashboard_charts_controller"
application.register("dashboard-charts", DashboardChartsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import RadioCardsController from "./radio_cards_controller"
application.register("radio-cards", RadioCardsController)

import ReservationOptionController from "./reservation_option_controller"
application.register("reservation-option", ReservationOptionController)

import TotalCostController from "./total_cost_controller"
application.register("total-cost", TotalCostController)
